import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const addCountertopCutoutMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Countertop Cutout',
		isVisible: ({ controller: { navigation, readonly }}): boolean => {
			return !readonly && navigation.displayMode !== DisplayMode.Overhead;
		},
		onClick: ({ position, controller, refMap }): void => {
			const { countertop, kitchen } = refMap;
			if (!countertop || !kitchen) return;

			const island = kitchen.design.islands.findById(countertop.islandIds[0]);
			if (!island) return;

			const { frontPanelId } = island.panels;
			if (!frontPanelId) return;

			controller.publishRequestedAction('add_cutout', frontPanelId, {
				position,
				countertopCutout: true
			});
		}
	};
};
